<!-- prettier-ignore -->

<button class="chat__button chat__button--stop" type="submit">
  <icon-stop />
</button>
